import { useTranslation } from "react-i18next";
import { PatternFormat } from "react-number-format";
import { Input } from "../../talentProfile/editForms/salaries/CustomInputs";

type Props = {
  error: boolean;
  value: string;
  disabled: boolean;
  onChange: (v: string) => void;
};

const OrderFlexibleStartField = ({
  error,
  disabled,
  value,
  onChange,
}: Props) => {
  const { t } = useTranslation("order");

  return (
    <PatternFormat
      disabled={disabled}
      value={value}
      error={error}
      valueIsNumericString
      format="##:##"
      customInput={Input}
      unit={t("flexibleShiftStartUnit")}
      maxWidth="158px"
      onValueChange={(values) => onChange(values.value)}
    />
  );
};

export default OrderFlexibleStartField;
